import React from "react";

import CardWrapper from "./components/CardWrapper";

function App() {
  return <CardWrapper />;
}

export default App;
